// extracted by mini-css-extract-plugin
export default {"flags":"w1Zccv","flag":"S__viB","active":"VxPp95"};